import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserSession } from '../../interfaces/user-session';
import { AuthProvider } from '../../enums/auth-provider';
import { UtilityFunctions } from '../../utilities/utility-functions';

@Injectable({
    providedIn: 'root'
})

export class SettingsService {

    private _apiBaseUrl: string = "";

    public constructor(private http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        this._apiBaseUrl = apiBaseUrl;
    }

    public getSettings = (): Observable<any> => {

        let result: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
        const apiPath: string = "settings/getsettings";
        const fullPath: string = this._apiBaseUrl + apiPath;
        let httpOptions: any = null;

        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

        } else {

            httpOptions = { headers: new HttpHeaders({ "content-type": "application/json" }) };
        }

        this.http.get<any>(fullPath, httpOptions).subscribe((settings: any) => {

            result.next(settings);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }
}
